import React from "react";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import reviewEmployeesToDelete from "../../../../../../../usecases/employees/review-employees-to-delete";
import useStyles from "./styles";

export default function StepFooter({
  employees,
  isLoading,
  currentStep,
  overrideLabel,
  overrideAction,
  hasNoData,
  target,
}) {
  const { button, container, disabled } = useStyles();
  return (
    <Grid item container xs={12} className={container}>
      {(!hasNoData || isLoading) && (
        <Grid xs={6} item container alignItems="center" justify="flex-start">
          {!isLoading && (
            <Typography variant="body1">
              {t("employees-section.employees-will-be-deleted", {
                numEmployees: employees.length,
              })}
            </Typography>
          )}
        </Grid>
      )}
      <Grid
        xs={!(hasNoData && !isLoading) ? 6 : 12}
        item
        container
        alignItems="flex-end"
        justify={!(hasNoData && !isLoading) ? "flex-end" : "center"}
      >
        <Button
          className={`${button} ${isLoading && disabled}`}
          onClick={() => {
            if (overrideAction) {
              overrideAction();
            } else {
              reviewEmployeesToDelete({
                employees,
                currentStep: currentStep + 1,
                target,
              });
            }
          }}
          disabled={isLoading}
        >
          {overrideLabel || t("actions.continue")}
        </Button>
      </Grid>
    </Grid>
  );
}

StepFooter.defaultProps = {
  isLoading: false,
  overrideLabel: undefined,
  overrideAction: undefined,
  hasNoData: false,
};

StepFooter.propTypes = {
  employees: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  currentStep: PropTypes.number.isRequired,
  overrideLabel: PropTypes.string,
  overrideAction: PropTypes.func,
  hasNoData: PropTypes.bool,
};
